/* eslint-disable no-bitwise */
/* eslint-disable no-unused-consts */
/* eslint-disable no-useless-escape */

const map = apiKey => {
  const mapElement = document.querySelector('.js-map-canvas');

  if (mapElement) {
    const image = `${
      window.location.origin
    }/wp-content/themes/forum-ekonomiczne-chisel/dist/assets/images/svg/pin.svg`;
    let map;

    const mapStyle = [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#bdbdbd',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dadada',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#c9c9c9',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
    ];

    /**
     * Ajax data
     */
    const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
    window.markers = [];
    let data = {
      action: 'get_map_data',
    };
    let urlParameters = Object.entries(data)
      .map(e => e.join('='))
      .join('&');

    window.initMap = () => {
      const c = new google.maps.LatLng(52.2351189, 21.0313665);
      const mapOptions = {
        zoom: 16,
        zoomControl: false,
        center: c,
        styles: mapStyle,
        scrollwheel: false,
        scaleControl: false,
        draggable: true,
        mapTypeControl: false,
        disableDefaultUI: true,
      };
      map = new google.maps.Map(mapElement, mapOptions);
      ajaxGetMarkers(map);
    };

    /**
     * Ajax for API Key
     */
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function() {
      const data = JSON.parse(this.response);

      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${
        data.api_key
      }&callback=initMap&libraries=places`;
      document.body.appendChild(script);
    };
    request.onerror = function() {
      // Connection error
    };
    request.send(urlParameters);

    /**
     * Ajax for map markers
     */
    const ajaxGetMarkers = map => {
      let request_map = new XMLHttpRequest();
      request_map.open('POST', ajax_url, true);
      request_map.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );
      request_map.onload = function() {
        const data = JSON.parse(this.response);

        data.geo.forEach(element => {
          if (element.location !== null) {
            let marker = new google.maps.Marker({
              position: new google.maps.LatLng(
                element.latitude,
                element.longitude,
              ),
              clickable: false,
              icon: image,
            });

            marker.setMap(map);
            markers.push(marker);
          }
        });
      };
      request_map.onerror = function() {
        // Connection error
      };
      request_map.send(urlParameters);
    };
  }
};

export default map;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/map.js